import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { SortEnumType } from 'gql/graphql';
import { getWorkOrderVersionListItems } from 'pages/Project/Common/utils';

import { useEffect, useMemo } from 'react';

import { bimWorkOrderChangePreviousVersionsGql } from '../exportWorkOrderChangeAnalyticsQueries';

const requestId = 'bimGetExportWorkOrderVersions';

export const useBimWorkOrderVersionsItems = (workOrderChangeId: number, withEffect = true) => {
    const variables = useMemo(
        () => ({
            workOrderChangeId,
            order: {
                workOrderVersionItem: {
                    id: SortEnumType.Desc,
                },
            },
        }),
        [workOrderChangeId],
    );

    const [bimExportWorkOrderChangeAnalyticsAsExcelReset] = useResetStoreData({ requestId });

    const [bimWorkOrderVersionsData] = useRequest({
        requestId,
        query: bimWorkOrderChangePreviousVersionsGql,
        variables,
        withEffect,
    });

    useEffect(() => {
        bimExportWorkOrderChangeAnalyticsAsExcelReset(undefined);
    }, [bimExportWorkOrderChangeAnalyticsAsExcelReset]);

    return useMemo(
        () =>
            getWorkOrderVersionListItems(
                bimWorkOrderVersionsData?.bimWorkOrderChangePreviousVersionsAsync?.items ?? [],
            ),
        [bimWorkOrderVersionsData?.bimWorkOrderChangePreviousVersionsAsync?.items],
    );
};
